<template>
  <form
    class="add-form"
    ref="profile_form"
    @submit.prevent="handleSubmit"
    @keydown.enter.prevent="() => {}"
  >
    <div class="form-wrapper" v-if="!blackListUser.id">
      <!-- User -->
      <base-input
        :label="`${$t('COMMON.USER')} (*)`"
        :placeholder="$t('COMMON.USER')"
        v-if="$currentUserCan($permissions.PERM_VIEW_ANY_USERS)"
      >
        <user-selector
          :user="blackListUser.user.id"
          :filterable="true"
          :showAll="false"
          @userChanged="
            (userId, user) => {
              blackListUser.user.id = userId;
              onFormChanged();
            }
          "
        />
      </base-input>
      <validation-error :errors="apiValidationErrors.user" />
    </div>
    <div class="form-wrapper full" v-else>
      {{ blackListUser.user.firstname+' '+blackListUser.user.lastname+' - '+blackListUser.user.email }}
    </div>
    <div class="form-wrapper" v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)">
      <!-- Organization -->
      <base-input
        :label="`${$t('COMMON.ORGANIZATION')} (*)`"
        :placeholder="$t('COMMON.ORGANIZATION')"
        
      >
        <organization-selector
          :organization="blackListUser.organization.id"
          :filterable="true"
          :showAll="false"
          @organizationChanged="
            (organizationId, organization) => {
              blackListUser.organization.id = organizationId;
              onFormChanged();
            }
          "
        />
      </base-input>
      <validation-error :errors="apiValidationErrors.organization" />
    </div>

    <div class="form-wrapper full">
      <base-input
        :label="$t('BLACK_LIST_USERS.EXCERPT')"
        :placeholder="$t('BLACK_LIST_USERS.EXCERPT')"
      >
        <html-editor v-model="blackListUser.excerpt" @change="onFormChanged()">
        </html-editor>
      </base-input>
      <validation-error :errors="apiValidationErrors.excerpt" />
    </div>
    <div class="submit-wrapper">
      <base-button
        type="button"
        class="btn btn-sm elite-submit"
        native-type="submit"
        :disabled="loading"
      >
        <i class="fas fa-spinner fa-spin" v-if="loading"></i>
        {{
          blackListUser.id ? $t("BLACK_LIST_USERS.EDIT_BLACK_LIST_USER") : $t("BLACK_LIST_USERS.ADD_BLACK_LIST_USER")
        }}
      </base-button>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue';
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import ValidationError from "@/components/ValidationError.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import models from "@/constants/models";
import "flatpickr/dist/flatpickr.css";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import UserSelector from "@/components/UserSelector.vue";
import blackListUsers from '../../../../../i18n/fr/blackListUsers';

export default {
  layout: "DashboardLayout",

  components: {
    HtmlEditor,
    BaseInput,
    ValidationError,
    OrganizationSelector,
    UserSelector,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [formMixin],

  props: ["blackListUserData", "formErrors", "loading"],

  data() {
    let blackListUserData = cloneDeep(this.blackListUserData);
    blackListUserData = this.$fillUserOrganizationData(blackListUserData);
    return {
      blackListUser: blackListUserData,
      permissions: [],
      users: [],
      permissionsModel: {},
      models: models,
    };
  },

  created() {},

  mounted() {
    this.getUsers();
  },

  methods: {

    async getUsers() {
      await this.$store.dispatch("users/list");
      this.users = this.$store.getters["users/list"];
    },
    async handleSubmit() {
      let blackListUserData = cloneDeep(this.blackListUser);
      blackListUserData = this.$fillUserOrganizationData(blackListUserData);
      this.$emit("blackListUserSubmitted", blackListUserData);
    },

    onFormChanged() {
      this.$emit("formChanged");
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
    blackListUserData(blackListUserData) {
      if (blackListUserData) {
        this.blackListUser = {
          ...this.blackListUser,
          ...cloneDeep(blackListUserData),
        };
      }
    },
  },
};
</script>
